for (const link of document.querySelectorAll('header a[href*="/collections/"], [data-drawer] a[href*="/collections/"], .mobile-nav a[href*="/collections/"]')) {
  const target = new URL(link.href, location.origin);
  if (!/\/collections\/headwear\/?$/.test(target.pathname)) continue;
  for (let parent = link.parentElement.parentElement; parent && parent !== document.body; parent = parent.parentElement) {
    const parentLink = parent.querySelector(':scope > a[href*="/collections/"]');
    if (!parentLink || parentLink === link) continue;
    const handle = new URL(parentLink.href, location.origin).pathname.split('/').filter(Boolean).at(-1);
    if (!['all-mens', 'all-womens'].includes(handle)) continue;
    target.searchParams.set('ur_audience', handle === 'all-mens' ? 'men' : 'women');
    link.href = target.href;
    break;
  }
}
